import { IDictionary } from '~utilities/IDictionary';
import IncomeTrustClassTypeEnum from './IncomeTrustClassTypeEnum';

const classTypeLabels: IDictionary<string> = {
    [IncomeTrustClassTypeEnum.ClassC]: 'Class C',
    [IncomeTrustClassTypeEnum.ClassD]: 'Class D',
};

export default classTypeLabels;